<template>
  <div class="popup" id="popup">
    <div class="popup__container">
      <div class="popup__container-header">
        <h1 class="popup__container-header--en">{{non_hijri}}</h1>
        <h1 class="popup__container-header--ar">{{monthsNameArabic}}</h1>
        <router-link class="popup__container-header--close" to="/">&#10006;</router-link>
      </div>
      <div class="popup__container-details">
        <table class="popup__container-details--table">
          <tr class="popup__container-details--table-tr">
            <th>Date</th>
            <th>Day</th>
            <th>Fajr</th>
            <th>Sunrise</th>
            <th>Zuhr</th>
            <th>Asr</th>
            <th>Magrib</th>
            <th>Isha</th>
            <th>Hijri</th>
          </tr>
          <tr
            v-for="(table, index) of monthlyTable"
            :key="index"
            class="popup__container-details--table-tr"
          >
            <td>{{table['nextDate']}}</td>
            <td>{{table['nextDay']}}</td>
            <td>{{zeroPadding(table['fajr']['hour'])}}:{{zeroPadding(table['fajr']['minute'])}}</td>
            <td>{{zeroPadding(table['sunrise']['hour'])}}:{{zeroPadding(table['sunrise']['minute'])}}</td>
            <td>{{zeroPadding(table['zuhr']['hour'])}}:{{zeroPadding(table['zuhr']['minute'])}}</td>
            <td>{{zeroPadding(table['asr']['hour'])}}:{{zeroPadding(table['asr']['minute'])}}</td>
            <td>{{zeroPadding(table['magrib']['hour'])}}:{{zeroPadding(table['magrib']['minute'])}}</td>
            <td>{{zeroPadding(table['isha']['hour'])}}:{{zeroPadding(table['isha']['minute'])}}</td>
            <td>{{table['currentHijriDay']}}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import GetTimeTable from "./../data";
import {
  addDays,
  daysOfWeek,
  monthNames,
  monthNamesAR,
  monthNamesFI
} from "./../helpers";
export default {
  name: "MontlyCalender",
  props: ["month"],
  data() {
    return {
      showMonth: null,
      monthlyData: null,
      monthlyTable: [],
      monthsNameArabic: "",
      hijri_year: "",
      non_hijri: ""
    };
  },
  methods: {
    zeroPadding(value) {
      return value < 10 ? "0" + value : value;
    }
  },
  created() {
    let date = new Date();

    let currentMonth = monthNames.indexOf(this.month);
    const getTimeTable = new GetTimeTable();
    this.monthlyData = getTimeTable.getMonthlyData(currentMonth + 1);

    let hijriWords = [];

    //Next week salaahs
    for (let i = 0; i < this.monthlyData.length; i++) {
      let currentDate = addDays(new Date(date.getFullYear(), currentMonth), i);
      let currentSalah = getTimeTable.getByDay(
        currentDate.getDate(),
        currentDate.getMonth() + 1
      );
      let nextDate = currentDate.getDate() + "." + (currentDate.getMonth() + 1);
      let nextDay = daysOfWeek[currentDate.getDay()];
      let hijri = new Intl.DateTimeFormat("en-TN-u-ca-islamic", {
        day: "numeric",
        month: "long",
        weekday: "long",
        year: "numeric"
      });
      let currentHijri = hijri.format(currentDate);
      let hijriStart = currentHijri.lastIndexOf(",") - 2;
      let currentHijriDay = currentHijri.substr(hijriStart, 2).trim();

      let hijri2 = new Intl.DateTimeFormat("en-TN-u-ca-islamic").format(
        currentDate
      );
      let m = hijri2
        .substring(hijri2.indexOf("/") - 2, hijri2.indexOf("/"))
        .trim();
      /* let d = hijri2.substring(hijri2.indexOf("/") + 1, hijri2.lastIndexOf("/")).trim(); */
      let y = hijri2
        .substring(hijri2.lastIndexOf("/") + 1, hijri2.lastIndexOf("/") + 5)
        .trim();

      if (hijriWords.indexOf(monthNamesAR[m - 1]) === -1) {
        hijriWords.push(monthNamesAR[m - 1]);
      }

      this.hijri_year = y;

      let make_obj = { ...currentSalah, nextDate, nextDay, currentHijriDay };
      this.monthlyTable.push(make_obj);
    }

    this.monthsNameArabic = hijriWords.join(" - ") + " " + this.hijri_year;
    this.non_hijri =
      monthNames[monthNames.indexOf(this.month)] +
      "/" +
      monthNamesFI[monthNames.indexOf(this.month)] +
      " " +
      new Date().getFullYear();
  }
};
</script>